// Dependencies: 
import cookie from 'webmd-cookie';
import debug from 'webmd-debug';
// A global object to load the Quality Targeting signals on the page

if (typeof window !== 'undefined') {

  window.PQ = window.PQ || { cmd: [] };

  (function () {

    //PPE-379353 : Disable Vendor
    //Disable vendor if url containts vendor=0 or doubleverify=0
    var url = (document.referrer) ? document.referrer : document.location.href;
    if (url && (url.indexOf('vendor=0') > -1 || url.indexOf('dv=0') > -1)) {
      return false;
    }

    // block vendor on sensitive pages 
    if (window.s_sensitive && window.s_sensitive === "true") {
      return false;
    }

    // Disable vendor based on ads admin tool data
    if(window.globalConfig && window.globalConfig.ads) {

      let vendorConfig = window.globalConfig.ads.vendorConfig;
      let dvConfig = vendorConfig.doubleVerify ? vendorConfig.doubleVerify : {};
      let location = cookie.getJson('gtinfo');
			
      /**
       *  Gtinfo cookie stores country code in lowercase while admin tool db stores in uppercase
       *  hence text transform is done.
       */
      let isLocationAdded = false;
      let countryCode = location.cntr ? location.cntr.toUpperCase() : '';
      let locationList = dvConfig.location ? dvConfig.location : [];
                                                                                                                                    
      /** 
       *  If the gtinfo is not available and only some of the locations are selelcted, 
       *  location based vendor suppression cannot be done properly. Hence, vendors can be loaded 
       *  as default behavior. 
       * 
       *  If location property is undefined or no countries are added in location array 
       *  or all the countries are selected, then it can be considered as 
       *  all the locations are selected and not required to check for gtinfo.
       *  Countries available in WebMD gtinfo file : 249
       */
      if ( !(countryCode == '' && locationList.length > 0 && locationList.length < 249) ) {
        if ( locationList.length == 0 || locationList.length == 249 || locationList.includes(countryCode) ) {
          isLocationAdded = true;
        }
        /**
         *  If disable is true and the location is included in the location array, 
         *  then vendor should not be loaded.   
         *  If disable is set to false and certain countries are added in location array, 
         *  then for the countries that are not added in the array can be considered 
         *  to have disable : true and vendor should not be loaded in this case. 
         */
        if (dvConfig.disable && isLocationAdded) {
          return false;
        } else if ( !(dvConfig.disable) && !isLocationAdded ) {
          return false;			
        }
      }
    }

    // if in iframe exit;
    if (window.top !== window.self) {
      return;
    }

    // prevent script to be loaded if location other than USA 
    // Update: Making it only for webmd, it will be fired on vitals across all locations
    
    if (cookie.get('gtinfo') && document.location.hostname.indexOf('doctor.') == -1 && document.location.hostname.indexOf('.webmd') > -1 ) {
      let locCookie = cookie.get('gtinfo').split(','); 
      for (let element of locCookie) {
        let [key, val] = element.split(':');
        if (key === '"cntr"' && val !== '"usa"') {
          return false;
        }
      }
    }

    //PPE-411484 don't execute on member pages
    // if we are on member or webmdrx page, return immediately
    if ((/member.|webmdrx\./).test(location.host)) {
      return;
    }


    // Load doubleverify script
    function dvLoad() {

      var dvs, node, useSSL;

      // Asynchronously load the doubleverify code
      dvs = document.createElement("script");
      dvs.async = true;
      dvs.type = "text/javascript";
      useSSL = "https:" === document.location.protocol;
      dvs.src = (useSSL ? "https:" : "http:") + "//pub.doubleverify.com/dvtag/17778638/DV587414/pub.js";
      node = document.getElementsByTagName("script")[0];
      node.parentNode.insertBefore(dvs, node);

      /**
       * performance mark to spot when double-verify code has started loading
       */
      try {
        window.performance.mark('double-verify-load-start');
        window.performance.measure('measure-double-verify-load-start', 'ads-code-load', 'double-verify-load-start');
        debug('(Perf-Mark) Double-verify load started -> ' + window.performance.getEntriesByName('measure-double-verify-load-start', 'measure')[0].duration);

        dvs.onload = function () {
          /**
           * performance mark to spot when double-verify code has loaded
           */
          window.performance.mark('double-verify-loaded');
          window.performance.measure('measure-double-verify-loaded', 'ads-code-load', 'double-verify-loaded');
          debug('(Perf-Mark) Double-verify loaded -> ' + window.performance.getEntriesByName('measure-double-verify-loaded', 'measure')[0].duration);
        };
        
      } catch (e) {
        debug(e);
      }
      

      dvs.onerror = function() {
        debug('double verify not loaded on error');
        window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-dv", "webmd-dv-load-failed");
      }
    };
    /**
    * we need to load Double Verify once __tcfapiPromise is resolved,
    * the Promise is resolved once tcfapi.js is loaded onto the page
    * 
    * tcfapi.js is loaded only in EU locations and in other locations the Promise is
    * resolved immediately (handled in IAB stub code - webmd-ccm.js)
    */
    Promise.resolve(window.__tcfapiPromise).then(function () {
      
      dvLoad();

    });
    
  })();

}
